import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";

export default function Login() {
  const navigate = useNavigate();
  const { login } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const res = await login(email.trim(), password);
    setLoading(false);
    if (res.ok) { toast.success("Welcome back!"); navigate("/"); }
    else toast.error(res.error || "Login failed");
  };

  return (
    <div className="min-h-[calc(100vh-4rem)] nerd-gradient flex items-center justify-center px-4 py-16">
      <div className="w-full max-w-md animate-fade-up">
        <div className="bg-nerd-card border border-black/8 rounded-3xl p-8 shadow-2xl">
          <div className="w-11 h-11 rounded-2xl bg-nerd-light flex items-center justify-center mb-6">
            <img src="/logo-black.png" alt="Flavour Intelligence" className="w-6 h-6 object-contain" />
          </div>
          <h1 className="font-display text-3xl font-extrabold tracking-tight mb-1">Welcome back</h1>
          <p className="text-nerd-light/50 text-sm mb-7">Log in to save recipes and plan your week.</p>
          <form onSubmit={submit} className="space-y-4">
            <div>
              <label className="text-xs font-mono-x uppercase tracking-widest text-nerd-light/50 mb-1.5 block">Email</label>
              <input data-testid="login-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
                className="w-full bg-nerd-depth border border-black/10 rounded-xl px-4 py-3 text-sm outline-none focus:border-mint transition-colors" placeholder="you@email.com" />
            </div>
            <div>
              <label className="text-xs font-mono-x uppercase tracking-widest text-nerd-light/50 mb-1.5 block">Password</label>
              <input data-testid="login-password" type="password" required value={password} onChange={(e) => setPassword(e.target.value)}
                className="w-full bg-nerd-depth border border-black/10 rounded-xl px-4 py-3 text-sm outline-none focus:border-mint transition-colors" placeholder="••••••••" />
              <div className="text-right mt-1.5">
                <Link to="/forgot-password" data-testid="go-forgot-password" className="text-xs font-medium text-nerd-light/50 hover:text-nerd-light transition-colors">Forgot password?</Link>
              </div>
            </div>
            <button data-testid="login-submit" disabled={loading} type="submit"
              className="w-full inline-flex items-center justify-center gap-2 bg-nerd-light text-white font-semibold px-5 py-3 rounded-xl hover:opacity-90 transition-opacity disabled:opacity-60">
              {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : "Log in"}
            </button>
          </form>
          <p className="text-sm text-nerd-light/50 mt-6 text-center">
            No account? <Link to="/register" data-testid="go-register" className="text-nerd-light hover:underline">Create one</Link>
          </p>
        </div>
      </div>
    </div>
  );
}
